﻿export function setupShareThis() {
    
    window.setupPrint = function (articleId) {
        if ($('[data-main-content="' + articleId + '"]').length > 0) {
            $(this).find('[data-article-id]').removeClass().addClass("row");
        }
    };

    window.hidePrint = function () {
        $('[data-article-id]').removeClass().addClass("row d-print-none");
    };

    window.updateShareThis = function (url, title) {
        addthis.update('share', 'url', location.host + url);
        addthis.url = url;
        addthis.update('share', 'title', title);
        addthis.update('addthis_button_print', 'href', location.host + url);
        addthis.toolbox(".addthis_toolbox");
    }

    const articleId = $('[data-main-content]').data('main-content');
    if (articleId != null) {
        window.setupPrint(articleId);
    }
}
